// export const api = "http://192.168.68.110:3060/api"
export const api = "https://cochera-back.herokuapp.com/api"
